module.exports = __webpack_public_path__ + "img/UpperFixedA.8e24baf3.png";